// Forked into ../redesign/RecentSearches/index.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import { useTranslate } from '@bynder/localization';
import { useSelectRecentSearch } from '../hooks/useSelectRecentSearch';
import {
	StyledHeadingNoButton,
	StyledHeadingWrapper,
	StyledItemsUL,
	StyledResultsSection,
} from '../ResultsDropdown/StyledComponents';
import { RecentSearchItem } from './RecentSearchItem';
import { useSearch } from '../SpotlightState';

export function RecentSearches() {
	const { recentSearchTerms } = useSearch();
	const { translate } = useTranslate();
	const handleSearch = useSelectRecentSearch();

	if (recentSearchTerms.length === 0) {
		return null;
	}

	return (
		<StyledResultsSection>
			<StyledHeadingWrapper $noMarginTop>
				<StyledHeadingNoButton>
					<div>{translate('spotlightHelp.recentSearches')}</div>
				</StyledHeadingNoButton>
			</StyledHeadingWrapper>
			<StyledItemsUL>
				{recentSearchTerms.map((term: string) => (
					<RecentSearchItem term={term} onSelect={() => handleSearch(term)} key={term} />
				))}
			</StyledItemsUL>
		</StyledResultsSection>
	);
}
